// extracted by mini-css-extract-plugin
export default {"formWidth":"Users_formWidth__UY8OP","inputButton":"Users_inputButton__KV085","alignButtons":"Users_alignButtons__hcvz2","errorText":"Users_errorText__nJ5Fb"};